import { render, staticRenderFns } from "./TheRedirectLoader.vue?vue&type=template&id=2675d6ca"
import script from "./TheRedirectLoader.vue?vue&type=script&lang=js"
export * from "./TheRedirectLoader.vue?vue&type=script&lang=js"
import style0 from "./TheRedirectLoader.vue?vue&type=style&index=0&id=2675d6ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports